import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'
import { sendDonationChangedMessage } from './sdk-messenger'
import orderAmountSlice from 'modules/order/state/amount/order-amount-slice'
import orderCurrencySlice from 'modules/order/state/currency/order-currency-slice'
import orderFrequencySlice from 'modules/order/state/frequency/order-frequency-slice'
import orderContactSlice from 'modules/order/state/contact/contact-slice'
import orderAddressSlice from 'modules/order/state/address/address-slice'

export const sdkDonationChangedMiddleware = createListenerMiddleware<RootState>()

// Define listeners for multiple actions
sdkDonationChangedMiddleware.startListening({
  matcher: isAnyOf(
    orderAmountSlice.actions.setValue,
    orderFrequencySlice.actions.setValue,
    orderCurrencySlice.actions.setValue,
    orderContactSlice.actions.setValue,
    orderAddressSlice.actions.setValue,
  ),
  effect: (_, listenerApi) => {
    const state = listenerApi.getState()

    sendDonationChangedMessage(state.config.campaignId, {
      // donation
      frequency: state.order.frequency.value,
      amount: state.order.amount.value,
      currency: state.order.currency.value,
      // contact
      first: state.order.contact.firstName,
      last: state.order.contact.lastName,
      email: state.order.contact.email,
      phone: state.order.contact.phone,
      // address
      zip: state.order.address.value.zipCode,
      street: state.order.address.value.line1,
      city: state.order.address.value.city,
      state: state.order.address.value.state,
      country: state.order.address.value.country,
      // options
      designation: state.order.designation.value.designationId,
      // tracking
      c_src: state.urlParams.c_src,
      c_src2: state.urlParams.c_src2,
      referrer: state.urlParams.referrer,
    })
  },
})
